import { judicialProcedure } from "../abstractLitigationCase/fullFormDefinition";
import { overwriteFormElementField } from "../formDefinitionFunctions";
import { FormElementPropsWithoutProduct } from "../../../../components/Case/CaseForm/FormElement";
import { DataLeakContract } from "../../../../types/Products/ContractLaw/DataLeakContract";

export function overwriteJudicialProcedure(
  product: DataLeakContract,
  dataLeakSpecificJudicialProcedureFields: FormElementPropsWithoutProduct<DataLeakContract>[]
) {
  const base = judicialProcedure(product, dataLeakSpecificJudicialProcedureFields);

  overwriteFormElementField<DataLeakContract>(
    base.elements,
    `${product.productClassName}.valueInDisputeJudicialPreliminary`,
    {
      isDisabled: ({ product }) => false,
    }
  );

  overwriteFormElementField<DataLeakContract>(
    base.elements,
    `${product.productClassName}.valueInDisputeJudicialFinal`,
    {
      isDisabled: ({ product }) => false,
    }
  );

  overwriteFormElementField<DataLeakContract>(
    base.elements,
    `${product.productClassName}.subtractExtrajudicialProcessFee`,
    {
      isDisabled: ({ product }) => false,
    }
  );

  overwriteFormElementField<DataLeakContract>(
    base.elements,
    `${product.productClassName}.costBearingByOpponentRelative`,
    {
      isDisabled: ({ product }) => false,
    }
  );

  return base;
}
